// Core
import React from "react";

const Contact = (props) => {
    return (
        <div className = 'contact'>
            <span className = 'action'>{props.action}</span>
            <span className = 'address'>{props.address}</span>
        </div>
    );
};

export default Contact;
